__webpack_require__.p = "//prod-assets.nike.in/NIKE/nes-nike-pay-new-svc/new-static-checkout/";